import React from "react";

const UserProfile = () => {
  const loginData: any = sessionStorage.getItem("loginData");
  const data = JSON.parse(loginData);

  return (
    <div className="profile-container">
      <div className="profile-card">
        <img src={data.userProfile} alt="Profile" className="profile-img" />

        <h2 className="profile-name">{data.name}</h2>

        <div className="profile-info">
          <p>
            <strong>Email:</strong> {data.email}
          </p>
          <p>
            <strong>Phone:</strong> {data.phone}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
